require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./sommerbetreuung-2020-under-3-j.json") })
        }
      }, "path---sommerbetreuung-2020-under-3-j");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---sommerbetreuung-2020-under-3-j!./.cache/json/sommerbetreuung-2020-under-3-j.json
// module id = 1149
// module chunks = 231608221292675